export default "__VITE_ASSET__Dj1LMysb__"